//Styles
import Styles from "./BaseAppContainer.module.scss";
import classnames from "classnames";

//module
import Draggable from 'react-draggable'

//Components
import WindowOptions from "./window-options/WindowOptions";

//Icon
import AppBar from "./app-bar/AppBar";
import { ReactNode, useState } from "react";
import SearchBox from "../search_box/SearchBox";


//Redux
import { closeWindow } from "../../actions";
import { RootStateOrAny, useDispatch } from "react-redux";
import { changeDragable } from "../../reducers/draggable";
import { useSelector } from "react-redux";
import { useTransition, animated } from "react-spring";
import { getSizeInRem, gotoPreviousOption } from "../../global/functions/functrions";

interface BaseAppContainerProps {
    appId: string;
    loadFromX: number;
    loadFromY?: number;
    width?: number;
    height?: number;
    title: string;
    SideBar?: ReactNode;
    MainScreen: ReactNode;
    showHeader?: boolean;
    showSearchBar?: boolean;
    lighTheme?: boolean;
    onClickPreviousIcon?: () => void;
    onClickNextIcon?: () => void;
}


const BaseAppContainer = ({ appId, loadFromX, loadFromY = 1000, width = 1000, height = 700, title, SideBar, MainScreen, showHeader = false, showSearchBar = true, lighTheme = false, onClickPreviousIcon, onClickNextIcon }: BaseAppContainerProps) => {

    const isDragable = useSelector((state:RootStateOrAny)=>state.changeDragable)

    const [isVisible, setIsVisible] = useState(true)

    const dispatch = useDispatch()

    const [showSidebarInit,setShowSidebar] = useState(true)

    const onClickPrevious=()=>{
        onClickPreviousIcon?.()
    }


    const onClickNext=()=>{
        onClickNextIcon?.()
    }

    const onClickCLoseWindow = () => {
        setIsVisible(false)
        setTimeout(() => {
            dispatch(closeWindow(appId))
        }, 100)
    }

    const transition = useTransition(isVisible, {
        from: {
            x: loadFromX, y: loadFromY, opacity: 0, scale: 0
        },
        enter: {
            x: 0, y: 0, opacity: 1, scale: 1
        },
        leave: {
            x: loadFromX, y: loadFromY, opacity: 0, scale: 0
        }
    })

    const toggleSidebar = ()=>{
        setShowSidebar(!showSidebarInit)
    }

    return (
        <>
            {
                transition((style) =>
                    <animated.div style={style}>
                        <Draggable disabled={!isDragable}>
                            <div className={classnames(Styles.container, "glassBackground")} style={{ width: getSizeInRem(width), height: getSizeInRem(height) }} >

                                {
                                    SideBar && showSidebarInit && (
                                        <div className={Styles.left_container}>
                                            <div className={Styles.window_options}>
                                                <WindowOptions onClickCLoseWindow={onClickCLoseWindow} />
                                            </div>

                                            {
                                                showSearchBar
                                                    ? <div className={Styles.search}> <SearchBox /></div>
                                                    : <div className={Styles.title_container}>
                                                        {title}
                                                    </div>
                                            }
                                            <div className={Styles.content}>
                                                {SideBar}
                                            </div>
                                        </div>
                                    )
                                }

                                <div className={classnames(Styles.right_container, lighTheme && Styles.lightMainTheme)} >
                                    {showHeader
                                        ? <AppBar title={title} windowOptions={!showSidebarInit&&<WindowOptions onClickCLoseWindow={onClickCLoseWindow} />} onSidebarIconClick={toggleSidebar} onClickNextIcon={onClickNext} onClickPreviousIcon={onClickPrevious}/>
                                        : <div className={Styles.right_title}>{title}</div>
                                    }
                                    <div className={Styles.content}>

                                        {MainScreen}
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </animated.div>
                )
            }
        </>
    )
}

export default BaseAppContainer
